import { MooringSwinging } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const MOORING_ARRIVAL_SWINGING_LIST_DATA_TAG = 'MooringArrivalSwinging';
const MOORING_DEPARTURE_SWINGING_LIST_DATA_TAG = 'MooringDepartureSwinging';
class MooringSwingingParser extends OldRecordsParser {
    constructor(protocolTypeId, dataTag, app) {
        super(protocolTypeId, FIXED_PROTOCOL_CONTENT_TYPE_IDS.MOORING_SWINGING, dataTag, app);
    }
    getPropsMapping() {
        return {
            port: 'port',
            status: 'status',
            freeText: 'freeText',
        };
    }
    createData(props, record) {
        const data = new MooringSwinging(props.port, props.status, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.port,
            };
            data.port = link;
        }
        return data;
    }
}
export class MooringArrivalSwingingParser extends MooringSwingingParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.MOORING_ARRIVAL_SWINGING, MOORING_ARRIVAL_SWINGING_LIST_DATA_TAG, app);
    }
}
export class MooringDepartureSwingingParser extends MooringSwingingParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.MOORING_DEPARTURE_SWINGING, MOORING_DEPARTURE_SWINGING_LIST_DATA_TAG, app);
    }
}
//# sourceMappingURL=MooringSwingingParser.js.map